import {BaseService} from '../baseService.js';

/* 
 * Handles interaction with the bundle and promotion api
 */
export class AuthGroupService extends BaseService {

	constructor() {	
		super();
	}
	
	async getGroupForCustomer(customerId) {		
		var data = await this.makeGETRequest('/api/resource/secure-fuel-auth-groups/' + customerId);		
		return data;		
	}

	async getRejectGroups(customerId) {		
		var query = '';
		if (customerId) {
			query = '?customerId=' + customerId;
		}
		var data = await this.makeGETRequest('/api/resource/secure-fuel-auth-groups/rejects' + query);		
		return data;		
	}
	
}

